import Profile from './components/Profile';
import Icon from 'components/common/Icon';

const TeamLinkleProfile = ({ userInfo, handleAction }: { userInfo?: UserInfo | null, handleAction: (action: 'call' | 'msg') => void }) => {
    if (!userInfo) return null;
    return <>
        <Profile userInfo={userInfo} isTeamLinkle={true}>
            <Profile.Image />
            <div className="flex flex-col">
                <div className="mt-4 flex items-center gap-2 mb-2">
                    <Profile.Name />
                </div>

                <hr className="m-0 h-[1px] w-full border-base-border-default" />

                <div className="mb-7 mt-4 flex items-center justify-between rounded-full bg-base-bg-subtle px-2 py-1">
                    <div className="flex items-center gap-1">
                        <Icon name="profile/profile.svg" className="flex-shrink-0 items-center justify-center px-2 py-1" size={24} />
                        <div className="flex flex-1 items-center justify-center gap-2 py-3">
                            <Profile.Stats type="follower" count={1000} />
                        </div>
                    </div>

                    <div className="flex items-center justify-center py-1">
                        <div className="flex items-center justify-center gap-1 rounded-full px-3 py-2 pointer-events-none opacity-50">
                            <Icon name={'inroom/check.svg'} className="flex-shrink-0 items-center justify-center px-2 py-1" size={24} />
                            <div className="typography-headline-sm text-btn-txt-normal">{brsc.following}</div>
                        </div>
                    </div>
                </div>

                <div className="mb-2 flex items-center justify-center gap-2">
                    <div onClick={() => handleAction('msg')} className="flex flex-1 items-center justify-center py-1">
                        <div className="flex flex-1 items-center justify-center gap-1 rounded-full bg-[#8D8AFF] px-5 py-4">
                            <Icon name="profile/message.svg" size={24} />
                            <div className="typography-headline-lg text-base-txt-primary">message</div>
                        </div>
                    </div>
                </div>
            </div>
        </Profile>
    </>;
};

export default TeamLinkleProfile;